import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { DirectivesModule } from '../../../../../components/directives.module';
import { PostRegimenEditComponent } from './post-regimen-edit.component';

const ROUTES: Routes = [
  { path: '', component: PostRegimenEditComponent, pathMatch: 'full' },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    DirectivesModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    RouterModule.forChild(ROUTES),
  ],
  declarations: [PostRegimenEditComponent],
  exports: [PostRegimenEditComponent],
})
export class PostRegimenEditModule {
}
